// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_SalvarParcelasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /recebimentos/salvar_parcelas — edita uma venda parcelada inteira numa
 * transação (chamado 2026-0067).
 *
 * `recebimento_id` é QUALQUER parcela da venda. Os campos da venda (data em que o cliente pagou,
 * forma, observações) valem para todas as parcelas; `parcelas` traz o que é de cada uma (data
 * disponível, taxa). Campo ausente = não muda. O valor de uma parcela não se edita.
 */
import { registerContract } from './validate'

export interface Recebimentos_SalvarParcelasInput {
recebimento_id: number
recebimento_data?: string
recebimento_forma_pagamento_id?: number
recebimento_observacoes?: string
parcelas?: undefined[]
}

registerContract('Recebimentos_SalvarParcelasInput', {
  recebimento_id:                 { type: 'number',  required: true },
  recebimento_data:               { type: 'string',  required: false },
  recebimento_forma_pagamento_id: { type: 'number',  required: false },
  recebimento_observacoes:        { type: 'string',  required: false },
  parcelas:                       { type: 'array',   required: false },
})
